<div class="bottom-menu">
  <div class="menu-item" replaceUrl="true" [routerLink]="[{outlets: { 'home': ['historical'] }}]" routerLinkActive="active" (click)="onItemClicked($event)">
    <mat-icon>list_alt</mat-icon>
    <span>{{'bottom_menu.historical' | translate}}</span>
  </div>
  <div class="menu-item" replaceUrl="true" [routerLink]="[{outlets: { 'home': ['greetings'] }}]" routerLinkActive="active" (click)="onItemClicked($event)">
    <img src="/imgs/icon.png" alt="">
    <span class="middle">{{'bottom_menu.mind_log' | translate}}</span>
  </div>
  <div class="menu-item" replaceUrl="true" [routerLink]="[{outlets: { 'home': ['profile'] }}]" routerLinkActive="active" (click)="onItemClicked($event)">
    <mat-icon>grid_view</mat-icon>
    <span>{{'bottom_menu.account' | translate}}</span>
  </div>
</div>